import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          main: {
            title: 'Get your personalized map or aerial photo!!',
            description: 'Mapa a la carta allows you to create a map or aerial photo tailored to your needs using the National Topographic Map at scales 1:25,000 and 1:50,000 or the most current aerial photography available in the National Aerial Orthophotography Plan.<br><br>You will have the possibility to define the area, incorporate content or customize the cover. You can download a pdf file and purchase paper copies.',
            LoginAdminButton: 'Administration access',
            exit: 'Exit',
            name: 'Username',
            code: 'Password',
            avisoTienda: 'Rigid board printing is temporarily unavailable due to renovation work. Sorry for the inconvenience.'
          },
          boxComponent: {
            buttonText: 'Enter',
            fastMapText: 'Generate in a few clicks your Mapa a la carta. Select area, insert title and... get your map.',
            fastmapTitle: 'FAST MAP',
            completeMapText: 'Generate a topographic map with maximum customization: add routes or images on the map, draw, configure the cover, etc.',
            completeMapTitle: 'CUSTOM MADE MAP',
            posterMapText: 'Special edition without cover, ideal for framing.',
            posterMapTitle: 'POSTER MAP',
            photoMapText: 'Generate a photo centered in your area of interest.',
            photoMapTitle: 'CUSTOM MADE PHOTO',
            seriesMapText: 'Generate a set of maps or photos with common settings and layouts.',
            seriesMapTitle: 'CARTOGRAPHIC SERIES'
          },
          foot: {
            clientInformation: 'Client information',
            productCatalog: 'Product catalog',
            purchaseConditions: 'Purchase conditions',
            pointsOfSale: 'Points of sale',
            contactUs: 'Contact us',
            otherInformation: 'Other information',
            FAQ: 'Frecuently asked questions',
            mapaWeb: 'Site Map',
            aboutUs: 'About us',
            politics: 'Politics',
            legalWarning: 'Legal warning',
            intelectualProperty: 'Intelectual property',
            privacy: 'Privacy and data protection',
            cookies: 'Cookie information',
            security: 'Security'
          },
          step1: {
            mapDesign: 'Map design',
            leftLabelTextTittle: 'MAP DESIGN',
            leftLabelDescription: 'Configure the contents that suits you',
            centerLabelTextTittle: 'COVER DESIGN',
            centerLabelDescription: 'Customize map information',
            rightLabelTextTittle: 'SUMMARY',
            rightLabelDescription: 'Download and acquire the results',
            product: 'Product',
            scale: 'Scale',
            orientation: 'Sheet orientation',
            orientationCartela: 'Placard orientation',
            cellDimension: 'Cell dimension',
            horizontal: 'Horizontal',
            vertical: 'Vertical',
            grid: 'Grid',
            coordinates: 'Coordinates',
            services: 'Print on top of the photo',
            seeGrid: 'Display grids',
            legend: 'Legend',
            background: 'Check the box to fill white areas with the color of the sea',
            addSheet: 'Add sheet',
            listSheet: 'Sheet list',
            selectSheet: 'Select',
            removeSheet: 'Delete',
            sheet: 'Sheet',
            configSerie: 'Series configuration',
            configSheet: 'Sheet configuration',
            elaborado: 'Elaborated',
            poster: 'Poster',
            photo: 'Photo'
          },
          step2: {
            coverDesign: 'Cover design',
            background: 'Background',
            texts: 'Texts',
            title: 'Title',
            subtitle: 'Subtitle',
            author: 'Author',
            image: 'Image',
            uploadImage: 'Upload image',
            adventure: 'Adventure',
            cartography: 'Cartography',
            cities: 'Cities',
            nature: 'Nature',
            landscape: 'Landscape',
            others: 'Others',
            saveImageChanges: 'Apply changes',
            error_pdf_1: 'An error occurred while generating the PDF',
            error_pdf_2: 'Type of error',
            error_pdf_3: 'Error identifier',
            error_pdf_4: 'Please send an email to <a href="mailto:consulta@cnig.es?subject=Error de Mapa a la Carta">consulta@cnig.es</a> with the error identifier (subject: Error de Mapa a la Carta).',
            applyAll: 'Apply to all',
            depLegal: 'Legal deposit',
            codBar: 'Barcode',
            selectedFile: 'File previously selected.',
            notSelectedFile: 'File not selected.'
          },
          step3: {
            summary: 'Summary',
            cover: 'Cover',
            mapArea: 'Map area',
            condicionesDeUso: {
              Parte1: 'I accept the',
              Parte2: 'terms of use',
              Parte3: 'of Mapa a la Carta'
            },
            generatePDF: 'Generate PDF',
            pdfDescription1: 'Download map in PDF format at maximum resolution.',
            pdfDescription2: 'This process may take a few minutes.',
            buyPrint: 'Adquire print copy',
            printDescription: 'Receive, by post, a duplicate of the map that has been generated.',
            paperType: 'Paper type',
            paper: {
              normal: 'Normal',
              resistent: 'Waterproof',
              plegado: 'Folded',
              liso: 'Flat',
              glossy: 'Glossy',
              rigid: 'Rigid',
              photo: 'Photographic'
            },
            presentation: 'Presentation',
            buy: 'BUY',
            addCart: 'ADD TO CART',
            price: 'Price without VAT (excluding delivery)',
            buyConditions: 'Purchase conditions',
            virtualShop: 'of the Virtual Store',
            frameColor: 'Frame color',
            loaderAltaRes: 'Generating PDF in high resolution.\nDo not close the browser, this process may take a few minutes.',
            generatingSheet: 'Generating {Hjs} sheets.',
            loaderWait: 'Downloading PDF\nWait a few seconds...',
            GroupTotal: 'Total Series:',
            add: 'Add',
            toCart: 'Go to cart',
            cartConfirmation: 'This product has already been added to the shopping cart. Do you want to add more copies or go to the cart?',
            afterCart: 'INFORMATION',
            stayPage: 'Stay on this page',
            orderAdded: 'Order added to shopping cart.'
          },
          dialog: {
            accept: 'Accept',
            noGeographicInformation: 'The selected area does not contain geographic information. Please select an area corresponding to Spain (Peninsula, Canary Islands and Balearic Islands).',
            noGeographicInformation2: 'The selected area does not contain enough geographic information. Please select an area corresponding to Spain (Peninsula, Canary Islands and Balearic Islands).',
            noSeriesParameters: 'You do not have all the requirements to enter this page. It must have at least 2 sheets and each sheet must have the title and author entered.',
            noSeriesParametersEspecial: 'You do not have all the requirements to enter this page. It must have at least 2 sheets and each sheet must have the title, author, NIPO, ISBN, Legal Deposit and barcode entered.',
            textFormError1: 'To complete the map you must enter the title and author.',
            textFormError1Serie: 'To complete the series, you must enter the title and author on all the sheets.',
            textFormError1Especial: 'To complete the special map, you must enter the title, author, NIPO, ISBN, Legal Deposit and barcode.',
            textFormError1SerieEspecial: 'To complete the special series, you must enter the title, author, NIPO, ISBN, Legal Deposit and barcode on all sheets.',
            notEnoughGeographicInformation: 'Part of the geographic information for the area is missing. Your printed map may have white areas.',
            uploadImage: 'Upload Image',
            errorHeavyFile: 'The image you have selected exceeds the size limit set',
            back: 'Back',
            allowedFormats: 'The allowed formats are',
            maxFileSize: 'The maximum image size is',
            bestResoultImage: 'To obtain the best results, the image should have a ratio of',
            uploadImageUpperCase: 'UPLOAD IMAGE',
            cancel: 'CANCEL',
            close: 'CLOSE',
            generatePDFWarning: 'You are about to generate a high resolution cartography in PDF format. The generated file can be heavy, around 150MB. Before proceeding, consider whether your device or data rate allows you to perform this download. This process may take a few minutes.',
            generatePDFCompleted: {
              Parte1: 'Your PDF of Mapa a la Carta has been generated successfully.',
              Parte2: 'You can download it now or access it later by copying the following link that will be',
              Parte3: 'available for 7 days:'
            },
            PDFGenerated: 'PDF generated',
            copyURL: 'COPY LINK',
            copyID: 'COPY CODE',
            copyAllURL: 'COPY LINKS',
            copyAllID: 'COPY CODES',
            download: 'DOWNLOAD',
            cancelUpperCase: 'CANCEL',
            oldpdf: 'Buy map',
            expiredpdf: 'The indicated ID has already expired',
            search: 'Search',
            idoldpdf: 'Map code',
            oldExplained: 'Search or order a previously generated map (7 days)',
            validerror: 'Invalid format',
            duplicateerror: 'Already present in the cart',
            existanceerror: 'There is no such PDF',
            RapidoElaborado: 'Fast or Custom',
            Poster: 'Poster',
            Foto: 'Photo',
            snackBarURL: 'URL copied to clipboard.',
            snackBarID: 'Code copied to the clipboard.',
            serialOptions: 'Going back and modifying these settings may cause loss of sheet settings.',
            minSheet: 'There must be at least 2 sheets to continue.',
            generateLegend: 'Generate legend',
            generateLegendWarning: 'It is recommended to configure the legend at the end of loading and symbolizing the data added to the map.',
            continue: 'CONTINUE'
          },
          tour: {
            seriesOptionsStep1: 'In the first tab you can configure the characteristics of the entire series. In the second, the number of sheets and their position.',
            productStep1: 'Choose the product to be used in the series.',
            step1FirstStepSeries: 'Choose the product that you want to consume MTN25 or MTN50.',
            mapHelpStep1: 'Enable help grids.',
            step1FirstStep: 'Firstable, choose the product that you want to consume MTN25 or MTN50.',
            step1SecondStep: 'Choose the scale of the map:\n• 60K -> 1:60.000\n• 50K -> 1:50.000\n• 40K -> 1:40.000\n• 30K -> 1:30.000\n• 25K -> 1:25.000\n• 20K -> 1:20.000',
            step1SecondStepFoto: 'Choose the scale of the map:\n• 25K -> 1:25.000\n• 10K -> 1:10.000\n• 5K -> 1:5.000\n• 2.5K -> 1:2.500',
            step1ThirdStep: 'Decide the map orientation(horizontal or vertical).',
            cartelaStep1: 'Decide the placard orientation(horizontal or vertical).',
            checkboxLegendStep1: 'Enable poster with elaborate legend.',
            step1FourthStep: 'You can select if you want to add coordinates to the map frame or add a grid layer with cells. After that, you can choose the dimension of the cells.',
            step1FifthStep: 'Inside this window you can select the printed area moving the frame of the map center.',
            hojaAddStep1: 'Add sheets to the series, up to a maximum of 10.',
            listHojaStep1: 'List of numbered sheets on the map.',
            listHojaStep2And3: 'List of numbered sheets.',
            applyAllStep2: 'Button to apply the same image, color and text settings to the rest of the sheets.',
            focusHojaStep1: 'Focus on the sheet.',
            deleteHojaStep1: 'Delete the sheet.',
            step1SixthStep: 'You can use the IGN search tool to help you find a desired location(CCAA, provinces, streets, ...)',
            step1SeventhStep: 'If you want to generate a map with concrete coordinates, your can use the coordeniate search tool.',
            step1EighthStep: 'You can use the fullscreen tool to help you use the other plugins.',
            step1NinthStep: 'With this tool you can add elements to the map such us points, lines, polygons and give it some style. You can also add your own layers.',
            step1NinthPointOneStep: 'Add user file. It allows several formats.',
            step1NinthPointTwoStep: 'Draw a point entity whose simbology can be changed. Press Esc to finish.',
            step1NinthPointThreeStep: 'Draw a line entity whose simbology can be changed. Press Esc to finish.',
            step1NinthPointFourStep: 'Draw a polygon entity whose simbology can be changed. Press Esc to finish.',
            step1NinthPointFiveStep: 'Add text whose simbology can be changed. Press Esc to finish.',
            step1NinthPointFiveTwoStep: 'Change style. Select an entity and change the style with the options in the left panel. Press Esc to finish.',
            step1NinthPointSixStep: 'Move an entity. Select an entity and move it to the desired ubication.',
            step1NinthPointSevenStep: 'Edit an entity. Select an entity and displace the vertices.',
            step1NinthPointEightStep: 'Delete an entity. Select the entity that you want to delete.',
            step1AddLegend: 'Generate legend from the entities.',
            step1NinthPointNineStep: 'Load route from the leisure and free time routes catalog. Press the path to load.',
            step1NinthPointTenStep: 'Save a geoJSON with the drawn entities',
            step1NinthPointElevenStep: 'Undo the last edition.',
            step1TenthStep: 'Map scale zoom.',
            step1EleventhStep: 'Print area zoom.',
            step1TwelveStep: 'Add an image to the map. Select the ubication and the prefered size.Insertar imagen en el mapa.',
            step1Or2Parameters: 'Customize your cover by adding your title (required), subtitle and author (required).',
            step1FirstStepPhoto: 'You can add your desired services to the map.',
            step2FirstStep: 'In this section, we will be customizing our cover. In the first place, select the background of the cover',
            specialStep2: 'Customize your cover by adding your title (required), subtitle, author (required), NIPO (required), ISBN (required), Legal Deposit (required), and barcode (required).',
            step2ThirdStep: 'It\'s time to customize your cover image. You can add your own image and edit it with this button. Once you finish editing, save your changes with the \'Apply changes\' button down below.',
            step2FourthStep: 'If you are not sure which image to pick. Don\'t you worry, we have a selection of images designed for this purpose. Just select a theme and pick your favourite one.',
            step2FifthStep: 'Once you are ready, check if you like the final result of the cover.',
            step3FirstStep: 'In the last section you can set the last details of the map. We can see the last preview of the cover.',
            step3SecondStep: 'Here you can see the map that will generate, check if the frame corresponds to the zone that your desire.',
            step3FourthStep: 'If you like the result and want to generate the map with high resolution or buy it, accept the terms of use.',
            step3FifthStep: 'To generate the high resolution map, press the button \'Generate PDF\', this preccess will take between 2 and 4 minutes.',
            step3SixthStep: 'If you want to buy map, first select the type of paper.\n• Normal: 75 gr/m2\n• Waterproof: 75 gr/m2. Synthetic material. Water repellent and tear resistant.',
            step3SixthStepPoster: 'If you want to buy map, first select the type of paper.\n• Normal: 75 gr/m2\n• Glossy\n• Rigid',
            step3SixthStepFoto: 'If you want to buy map, first select the type of paper.\n• Normal: 75 gr/m2\n• Photographic\n• Rigid',
            step3SeventhStep: 'You can select the presentation mode of the map too.',
            step3EighthStep: 'Lastly, select the number of copies, next to the copies selector you will see the last price. Clicking the add to cart button will save it and by clicking the buy button, it will redirect you to the IGN virtual shop to be able to finalize the purchase, only if there is nothing in the cart, otherwise it will redirect you to the cart to confirm the entire purchase from there.',
            priceSeriesStep3: 'Total price of the entire series.',
            step3PFirstStep: 'In the last section you can set the last details of the map. In the first place, select the color of the map frame',
            step3FFirstStep: 'In the last section you can set the last details of the map. In the first place, select the color of the photo frame',
            step3PFirstPointTwoStep: 'Customize your map adding your title (required), subtitle and author (required).',
            step3PFirstPointTwoStepSpecial: 'Customize your map by adding a title (required), subtitle, author (required), NIPO (required), ISBN (required), legal deposit (required), and barcode (required).'
          },
          wizardPanel: {
            help: 'Help'
          },
          shoppingCart: {
            downloadMap: 'Download map',
            unity: 'Unit',
            removeProduct: 'Remove Product',
            cartDetail: 'Cart Detail',
            name: 'Name',
            units: 'Units',
            priceWithoutIVA: 'Price (excl. VAT)',
            totalWithoutIVA: 'Total (excl. VAT)',
            addMoreMaps: 'Add more maps',
            buy: 'Buy',
            emptyCart: 'Empty cart',
          }
        }
      },
      es: {
        translation: {
          main: {
            title: '¡¡Consiga su mapa o foto aérea personalizada!!',
            description: 'Mapa a la carta le permite crear un mapa o foto aérea a su medida usando el Mapa Topográfico Nacional a escalas 1:25.000 y 1:50.000 o la fotografía aérea más actual disponible en el Plan Nacional de Ortofotografía Aérea.<br><br>Tendrá la posibilidad de definir la zona, incorporar contenidos o personalizar la portada. Podrá descargar un fichero pdf y adquirir copias en papel.',
            LoginAdminButton: 'Acceso administración',
            exit: 'Salir',
            name: 'Nombre de usuario',
            code: 'Código',
            avisoTienda: 'La impresión en soporte rígido se encuentra temporalmente suspendida por obras. Disculpen las molestias.'
          },
          boxComponent: {
            buttonText: 'Acceder',
            fastMapText: 'Genere en pocos clics su mapa a la carta. Seleccione área, inserte título y... obtenga su mapa.',
            fastmapTitle: 'MAPA RÁPIDO',
            completeMapText: 'Genere un mapa topográfico con la máxima personalización: añadir rutas o imágenes en el mapa, dibujar, configurar la cartela, etc.',
            completeMapTitle: 'MAPA ELABORADO',
            posterMapText: 'Edición especial sin cartela, ideal para enmarcar.',
            posterMapTitle: 'MAPA PÓSTER',
            photoMapText: 'Genere una foto aérea centrada en su zona de interés.',
            photoMapTitle: 'FOTO A LA CARTA',
            seriesMapText: 'Genere un conjunto de mapas o fotos con ajustes y diseños comunes.',
            seriesMapTitle: 'SERIE CARTOGRÁFICA'
          },
          foot: {
            clientInformation: 'Información al cliente',
            productCatalog: 'Catálogo de productos',
            purchaseConditions: 'Condiciones de compra',
            pointsOfSale: 'Puntos de venta',
            contactUs: 'Contactar',
            otherInformation: 'Otra información',
            FAQ: 'Preguntas frecuentes',
            mapaWeb: 'Mapa Web',
            aboutUs: 'Acerca de nosotros',
            politics: 'Políticas',
            legalWarning: 'Aviso legal',
            intelectualProperty: 'Propiedad intelectual',
            privacy: 'Privacidad y protección de datos',
            cookies: 'Información de cookies',
            security: 'Seguridad'
          },
          step1: {
            mapDesign: 'Diseño del mapa',
            leftLabelTextTittle: 'DISEÑO DEL MAPA',
            leftLabelDescription: 'Configure los contenidos a su medida',
            centerLabelTextTittle: 'DISEÑO DE LA PORTADA',
            centerLabelDescription: 'Personalice la información del mapa',
            rightLabelTextTittle: 'RESUMEN',
            rightLabelDescription: 'Descargue y adquiera los resultados',
            product: 'Producto',
            scale: 'Escala',
            orientation: 'Orientación de la hoja',
            orientationCartela: 'Orientación de la cartela',
            cellDimension: 'Dimensiones de las celda',
            horizontal: 'Horizontal',
            vertical: 'Vertical',
            grid: 'Cuadrícula',
            coordinates: 'Coordenadas',
            services: 'Imprimir sobre la foto',
            seeGrid: 'Visualizar cuadrículas',
            legend: 'Leyenda',
            background: 'Marque la casilla para rellenar las zonas blancas con el color del mar',
            addSheet: 'Añadir hoja',
            listSheet: 'Lista hojas',
            selectSheet: 'Seleccionar',
            removeSheet: 'Borrar',
            sheet: 'Hoja',
            configSerie: 'Configuración de la serie',
            configSheet: 'Configuración de la hoja',
            elaborado: 'Elaborado',
            poster: 'Póster',
            photo: 'Foto'
          },
          step2: {
            coverDesign: 'Diseño de la portada',
            background: 'Fondo',
            texts: 'Textos',
            title: 'Título',
            subtitle: 'Subtítulo',
            author: 'Autor/a',
            image: 'Imagen',
            uploadImage: 'Subir imagen',
            adventure: 'Aventuras',
            cartography: 'Cartografía',
            cities: 'Ciudades',
            nature: 'Naturaleza',
            landscape: 'Paisaje',
            others: 'Varios',
            saveImageChanges: 'Aplicar cambios',
            error_pdf_1: 'Ha ocurrido un error generando el PDF',
            error_pdf_2: 'Tipo de error',
            error_pdf_3: 'Identificador del error',
            error_pdf_4: 'Por favor, envíe un email a <a href="mailto:consulta@cnig.es?subject=Error de Mapa a la Carta">consulta@cnig.es</a> con el identificador del error (asunto del email: Error de Mapa a la Carta).',
            applyAll: 'Aplicar a todos',
            depLegal: 'Depósito legal',
            codBar: 'Código de barras',
            selectedFile: 'Archivo previamente seleccionado.',
            notSelectedFile: 'Archivo no seleccionado.'
          },
          step3: {
            summary: 'Resumen',
            cover: 'Portada',
            mapArea: 'Área del mapa',
            condicionesDeUso: {
              Parte1: 'Acepto las',
              Parte2: 'condiciones de uso',
              Parte3: 'de Mapa a la Carta'
            },
            generatePDF: 'Generar PDF',
            pdfDescription1: 'Descargar mapa en formato pdf a máxima resolución.',
            pdfDescription2: 'Este proceso puede durar unos minutos.',
            buyPrint: 'Adquirir copia impresa',
            printDescription: 'Recibir, por vía postal, un duplicado del mapa que se ha generado.',
            paperType: 'Tipo de papel',
            paper: {
              normal: 'Normal',
              resistent: 'Resistente',
              plegado: 'Plegado',
              liso: 'Liso',
              glossy: 'Satinado',
              rigid: 'Rígido',
              photo: 'Fotográfico'
            },
            presentation: 'Presentación',
            buy: 'COMPRAR',
            addCart: 'AÑADIR AL CARRITO',
            price: 'Precio sin IVA (envío no incluido)',
            buyConditions: 'Condiciones de compra',
            virtualShop: 'de la Tienda Virtual',
            frameColor: 'Color del marco',
            loaderAltaRes: 'Generando PDF en alta resolución.\nNo cierre el navegador, este proceso puede durar unos minutos.',
            generatingSheet: 'Generando {Hjs} hojas.',
            loaderWait: 'Descargando PDF\nEspere unos segundos...',
            GroupTotal: 'Total Serie:',
            add: 'Añadir',
            toCart: 'Ir al carrito',
            cartConfirmation: 'Este producto ya está añadido al carrito de la compra ¿quiere añadir más copias o dirigirse al carrito?',
            afterCart: 'INFORMACIÓN',
            stayPage: 'Permanecer en esta página',
            orderAdded: 'Pedido añadido al carrito de la compra.'
          },
          dialog: {
            accept: 'Aceptar',
            noGeographicInformation: 'El área seleccionada no contiene información geográfica. Por favor seleccione un área correspondiente a España (Península, Canarias y Baleares).',
            noGeographicInformation2: 'El área seleccionada no contiene suficiente información geográfica. Por favor seleccione un área correspondiente a España (Península, Canarias y Baleares).',
            noSeriesParameters: 'No tiene todos los requisitos para entrar en esta página. Tiene que tener como mínimo 2 hojas y cada hoja tiene que tener el título y el autor/a introducidos.',
            noSeriesParametersEspecial: 'No tiene todos los requisitos para entrar en esta página. Tiene que tener como mínimo 2 hojas y cada hoja tiene que tener el título, autor/a, NIPO, ISBN, Depósito Legal y código de barras introducidos.',
            textFormError1: 'Para completar el mapa debe introducir el título y el autor/a.',
            textFormError1Serie: 'Para completar la serie, debe introducir el título y autor/a en todas las hojas.',
            textFormError1Especial: 'Para completar mapa especial, debe introducir el título, autor/a, NIPO, ISBN, Depósito Legal y código de barras.',
            textFormError1SerieEspecial: 'Para completar la serie especial, debe introducir el título, autor/a, NIPO, ISBN, Depósito Legal y código de barras en todas las hojas.',
            notEnoughGeographicInformation: 'Falta parte de la información geográfica de la zona. Es posible que su mapa tenga zonas blancas al imprimir.',
            uploadImage: 'Subir Imagen',
            errorHeavyFile: 'La imagen que ha seleccionado excede el tamaño límite establecido',
            back: 'Volver',
            allowedFormats: 'Los formatos permitidos son',
            maxFileSize: 'El tamaño máximo de la imagen es de',
            bestResoultImage: 'Para un resultado óptimo, la imagen debe tener una proporción',
            uploadImageUpperCase: 'SUBIR IMAGEN',
            cancel: 'CANCELAR',
            close: 'CERRAR',
            generatePDFWarning: 'Está apunto de generar una cartografía en alta resolución en formato PDF. El archivo generado puede llegar a ser pesado, en torno a 150MB. Antes de continuar, considere si su dispositivo o tarifa de datos le permite realizar esta descarga. Este proceso puede durar unos minutos.',
            generatePDFCompleted: {
              Parte1: 'Su PDF de Mapa a la Carta se ha generado correctamente.',
              Parte2: 'Podrá descargarlo ahora o acceder más tarde copiando el siguiente enlace que estará',
              Parte3: 'disponible durante 7 días:'
            },
            PDFGenerated: 'PDF generado',
            copyURL: 'COPIAR ENLACE',
            copyID: 'COPIAR CÓDIGO',
            copyAllURL: 'COPIAR ENLACES',
            copyAllID: 'COPIAR CÓDIGOS',
            download: 'DESCARGAR',
            cancelUpperCase: 'CANCELAR',
            oldpdf: 'Comprar mapa',
            expiredpdf: 'El ID indicado ya se ha expirado',
            search: 'Buscar',
            idoldpdf: 'Código del mapa',
            oldExplained: 'Buscar o encargar un mapa generado anteriormente (7 días)',
            validerror: 'Formato no válido',
            duplicateerror: 'Ya presente en el carrito',
            existanceerror: 'No existe tal PDF',
            RapidoElaborado: 'Rápido o Elaborado',
            Poster: 'Póster',
            Foto: 'Foto',
            snackBarURL: 'URL copiada en el portapapeles.',
            snackBarID: 'Código copiado en el portapapeles.',
            serialOptions: 'Retroceder y modificar estas configuraciones puede causar perdida de configuración de hojas.',
            minSheet: 'Tiene que haber como mínimo 2 hojas para seguir adelante.',
            generateLegend: 'Generar leyenda',
            generateLegendWarning: 'Se recomienda configurar la leyenda al finalizar la carga y simbolización de los datos añadidos al mapa.',
            continue: 'CONTINUAR'
          },
          tour: {
            seriesOptionsStep1: 'En la primera pestaña se puede configurar las características de la serie completa. En la segunda, el número de hojas y su posición.',
            productStep1: 'Elija el producto que se usará en la serie.',
            step1FirstStepSeries: 'Elija el producto que quiera consumir entre MTN25 y MTN50.',
            mapHelpStep1: 'Habilitar cuadrículas de ayuda.',
            step1FirstStep: 'En primer lugar elija el producto que quiera consumir entre MTN25 y MTN50.',
            step1SecondStep: 'Escoja la escala del mapa generado:\n• 60K -> 1:60.000\n• 50K -> 1:50.000\n• 40K -> 1:40.000\n• 30K -> 1:30.000\n• 25K -> 1:25.000\n• 20K -> 1:20.000',
            step1SecondStepFoto: 'Escoja la escala del mapa generado:\n• 25K -> 1:25.000\n• 10K -> 1:10.000\n• 5K -> 1:5.000\n• 2.5K -> 1:2.500',
            step1ThirdStep: 'Decida la orientación del mapa (horizontal o vertical).',
            cartelaStep1: 'Decida la orientación de la cartela (horizontal o vertical).',
            checkboxLegendStep1: 'Habilitar póster con leyenda elaborada.',
            step1FourthStep: 'Puede añadir la cuadrícula y/o las coordenadas en el marco del mapa. Posteriormente, podrá seleccionar el ancho de la cuadrícula.',
            step1FifthStep: 'En esta ventana podrá seleccionar el área de impresión. Si pulsa sobre el marco del mapa, puede desplazarlo a otra zona. Con la rueda del ratón puede cambiar el zoom.',
            hojaAddStep1: 'Añadir hojas a la serie, hasta un máximo de 10.',
            listHojaStep1: 'Lista de hojas enumeradas en el mapa.',
            listHojaStep2And3: 'Lista de hojas enumeradas.',
            applyAllStep2: 'Botón para aplicar al resto de hojas las mismas configuraciones de imagen, color y textos.',
            focusHojaStep1: 'Centrarse en la hoja.',
            deleteHojaStep1: 'Borrar la hoja.',
            step1SixthStep: 'Utilice el buscador para localizar una ubicación concreta (CC.AA., provincia, población o dirección postal).',
            step1SeventhStep: 'Si necesita generar un mapa de unas coordenadas concretas, puede utilizar el buscador de coordenadas.',
            step1EighthStep: 'Poner el mapa a pantalla completa.',
            step1NinthStep: 'Con esta herramienta podrá añadir elementos al mapa. Puede agregar capas que ya existen, o dibujar sus propias geometrías. Si no tiene tiempo para continuar, podrá guardar sus cambios para continuar más tarde.',
            step1NinthPointOneStep: 'Añadir un archivo del usuario. Se admiten diferentes formatos.',
            step1NinthPointTwoStep: 'Dibujar una entidad puntual. Se puede elegir la simbología. Tecla Esc para finalizar.',
            step1NinthPointThreeStep: 'Dibujar una entidad lineal. Se puede elegir la simbología. Doble clic para finalizar.',
            step1NinthPointFourStep: 'Dibujar una entidad superficial. Se puede elegir la simbología. Doble clic para finalizar.',
            step1NinthPointFiveStep: 'Añadir un texto. Se puede elegir la simbología. Tecla Esc para finalizar.',
            step1NinthPointFiveTwoStep: 'Modificar estilo. Pulse la entidad y cambie el estilo en el cuadro de la izquierda. Tecla Esc para finalizar.',
            step1NinthPointSixStep: 'Desplazar una entidad. Pulse la entidad y muévala a la ubicación deseada.',
            step1NinthPointSevenStep: 'Editar una entidad. Pulse sobre la entidad y desplace los vértices.',
            step1NinthPointEightStep: 'Eliminar una entidad. Pulse sobre la entidad a eliminar.',
            step1AddLegend: 'Generar leyenda a partir de las entidades.',
            step1NinthPointNineStep: 'Cargar ruta del catálogo de rutas de ocio y tiempo libre. Pulse la ruta a cargar.',
            step1NinthPointTenStep: 'Guardar en un geoJSON las entidades dibujadas',
            step1NinthPointElevenStep: 'Deshacer la última edición realizada. Se pueden encadenar varias ediciones.',
            step1TenthStep: 'Zoom a la escala del mapa.',
            step1EleventhStep: 'Zoom al área de impresión.',
            step1TwelveStep: 'Insertar imagen en el mapa. Seleccione la ubicación de la imagen y el tamaño final.',
            step1Or2Parameters: 'Personaliza el mapa introduciendo un título (obligatorio), un subtítulo y un autor o autora (obligatorio).',
            step1FirstStepPhoto: 'Puede seleccionar los servicios que quiere agregar al mapa.',
            step2FirstStep: 'En esta sección, personalizaremos el color de la portada.',
            specialStep2: 'Personaliza el mapa introduciendo un título (obligatorio), un subtítulo, un autor o autora (obligatorio), un NIPO (obligatorio), un ISBN (obligatorio), un depósito legal (obligatorio) y un código de barras (obligatorio).',
            step2ThirdStep: 'Es hora de personalizar la imagen de la portada. Puedes añadir tu propia imagen y editarla a tu gusto. Cuando termines, presiona el botón \'Aplicar cambios\' de la parte inferior.',
            step2FourthStep: 'Si no puedes decidir la imagen. No te preocupes, tenemos una lista de imágenes predefinidas para que escojas. Selecciona el tema en las pestañas y elige la que más te guste.',
            step2FifthStep: 'Cuando lo tengas todo listo, comprueba si te gusta pues será el resultado final de portada.',
            step3FirstStep: 'En esta última sección daremos los últimos toques a nuestro mapa, aquí tenemos el resultado final de la portada.',
            step3SecondStep: 'Aquí tenemos el mapa que vamos a generar, compruebe que el cuadro coincide con la zona que desea generar.',
            step3FourthStep: 'Si el resultado es el deseado y desea generar el mapa en alta resolución o comprarlo, acepte las condiciones de uso.',
            step3FifthStep: 'Para generar el mapa en alta resolución, presione el botón \'Generar PDF\', este proceso suele durar entre 2-4 minutos.',
            step3SixthStep: 'En el caso de que desee comprar el mapa puede seleccionar el tipo de papel.\n• Normal: 75 gr/m2\n• Resistente: 75 gr/m2. Material sintético. Repele el agua y resistente al desgarro.',
            step3SixthStepPoster: 'En el caso de que desee comprar el mapa puede seleccionar el tipo de papel.\n• Normal: 75 gr/m2\n• Satinado\n• Rígido',
            step3SixthStepFoto: 'En el caso de que desee comprar el mapa puede seleccionar el tipo de papel.\n• Normal: 75 gr/m2\n• Fotográfico\n• Rígido',
            step3SeventhStep: 'En esta sección podremos elegir el modo de presentación del mapa.',
            step3EighthStep: 'Por último, seleccione el número de copias del mapa, podrá ver además el precio de todos los mapas, al pulsar añadir al carrito lo guardará en este y al pulsar comprar nos redirigirá a la tienda virtual de IGN para poder finalizar la compra, pero si hay algo en el carrito, te redirigirá a este para confirmar la compra entera desde ahí.',
            priceSeriesStep3: 'Precio total de toda la serie.',
            step3PFirstStep: 'En esta última sección daremos los últimos toques a nuestro mapa. Primero, selecciona un color para el marco del mapa.',
            step3FFirstStep: 'En esta última sección daremos los últimos toques a nuestro mapa. Primero, selecciona un color para el marco de la foto.',
            step3PFirstPointTwoStep: 'Personaliza tu mapa añadiendo un título (obligatorio), subtítulo y autor/a (obligatorio).',
            step3PFirstPointTwoStepSpecial: 'Personaliza tu mapa añadiendo un título (obligatorio), un subtítulo, un autor o autora (obligatorio), un NIPO (obligatorio), un ISBN (obligatorio), un depósito legal (obligatorio) y un código de barras (obligatorio).'
          },
          wizardPanel: {
            help: 'Ayuda'
          },
          shoppingCart: {
            downloadMap: 'Descargar mapa',
            unity: 'Unidad',
            removeProduct: 'Quitar producto',
            cartDetail: 'Detalle carrito',
            name: 'Nombre',
            units: 'Unidades',
            priceWithoutIVA: 'Precio (sin IVA)',
            totalWithoutIVA: 'Total (sin IVA)',
            addMoreMaps: 'Añadir más mapas',
            buy: 'Comprar',
            emptyCart: 'Vaciar carrito',
          }
        }
      },
      ca: {
        translation: {
          main: {
            title: 'Aconsegueixi el seu mapa topogràfic o foto aèria personalitzada!!',
            description: 'Mapa a la carta li permet crear un mapa o foto aèria a la seva mesura usant el Mapa Topogràfic Nacional a escales 1:25.000 i 1:50.000 o la fotografia aèria més actual disponible al Pla Nacional d\'Ortofotografia Aèria.<br><br>Tindrà la possibilitat de definir-ne l\'àrea, incorporar-hi continguts o personalitzar-ne la portada. Podrà obtenir un fitxer PDF i adquirir còpies en paper.',
            LoginAdminButton: 'Accés administració',
            exit: 'Sortir',
            name: "Nom d'usuari",
            code: 'Contrasenya',
            avisoTienda: 'La impressió en suport rígid està temporalment suspesa per obres. Disculpeu les molèsties'
          },
          boxComponent: {
            buttonText: 'Accedir',
            fastMapText: 'Generi en pocs clics el seu mapa a la carta. Seleccioni l’àrea, insereixi el títol i... obtingui el seu mapa.',
            fastmapTitle: 'MAPA RÀPID',
            completeMapText: 'Generi un mapa topogràfic amb la màxima personalització: afegir rutes o imatges al mapa, dibuixar, configurar la portada, etc.',
            completeMapTitle: 'MAPA ELABORAT',
            posterMapText: 'Edició especial sense cartel·la, ideal per emmarcar.',
            posterMapTitle: 'MAPA PÒSTER',
            photoMapText: 'Generi una foto aèria centrada en la seva zona d\'interès.',
            photoMapTitle: 'FOTO A LA CARTA',
            seriesMapText: 'Generi un conjunt de mapes o fotos amb ajustos i dissenys comuns.',
            seriesMapTitle: 'SÈRIE CARTOGRÀFICA'
          },
          foot: {
            clientInformation: 'Informació al client',
            productCatalog: 'Catàleg de productes',
            purchaseConditions: 'Condicions de compra',
            pointsOfSale: 'Punts de venda',
            contactUs: 'Contactar',
            otherInformation: 'Una altra informació',
            FAQ: 'Preguntes freqüents',
            mapaWeb: 'Mapa Web',
            aboutUs: 'Sobre nosaltres',
            politics: 'Polítiques',
            legalWarning: 'Avís legal',
            intelectualProperty: 'Propietat intel·lectual',
            privacy: 'Privacitat i protecció de dades',
            cookies: 'Informació de galetes',
            security: 'Seguretat'
          },
          step1: {
            mapDesign: 'Disseny del mapa',
            leftLabelTextTittle: 'DISSENY DEL MAPA',
            leftLabelDescription: 'Configuri els continguts a la seva mida',
            centerLabelTextTittle: 'DISSENY DE LA PORTADA',
            centerLabelDescription: 'Personalitzi la informació del mapa',
            rightLabelTextTittle: 'RESUM',
            rightLabelDescription: 'Descarregui\'n i adquireixi\'n els resultats',
            product: 'Producte',
            scale: 'Escala',
            orientation: 'Orientació del full',
            orientationCartela: 'Orientació de la cartela',
            cellDimension: 'Dimensions de les cel·les',
            horizontal: 'Horitzontal',
            vertical: 'Vertical',
            grid: 'Quadrícula',
            coordinates: 'Coordenades',
            services: 'Imprimir sobre la foto',
            seeGrid: 'Visualitzar quadrícules',
            legend: 'Llegenda',
            background: 'Marqueu la casella per emplenar les zones blanques amb el color del mar',
            addSheet: 'Afegir full',
            listSheet: 'Llista fulles',
            selectSheet: 'Seleccionar',
            removeSheet: 'Esborrar',
            sheet: 'Full',
            configSerie: 'Configuració de la sèrie',
            configSheet: 'Configuració del full',
            elaborado: 'Elaborat',
            poster: 'Pòster',
            photo: 'Foto'
          },
          step2: {
            coverDesign: 'Disseny de la portada',
            background: 'Fons',
            texts: 'Textos',
            title: 'Títol',
            subtitle: 'Subtítol',
            author: 'Autor/a',
            image: 'Imatge',
            uploadImage: 'Pujar imatge',
            adventure: 'Aventures',
            cartography: 'Cartografia',
            cities: 'Ciutats',
            nature: 'Naturalesa',
            landscape: 'Paisatge',
            others: 'Diversos',
            saveImageChanges: 'Aplicar canvis',
            error_pdf_1: 'S\'ha produït  un error en la generació del PDF',
            error_pdf_2: 'Tipus d\'error',
            error_pdf_3: 'Identificador de l\'error',
            error_pdf_4: 'Si us plau, enviï un email a <a href="mailto:consulta@cnig.es?subject=Error de Mapa a la Carta">consulta@cnig.es</a> amb l\'identificador de l\'error (assumpte de l\'email: Error de Mapa a la Carta).',
            applyAll: 'Aplicar a tots',
            depLegal: 'Dipòsit legal',
            codBar: 'Codi de barres',
            selectedFile: 'Fitxer prèviament seleccionat.',
            notSelectedFile: 'Fitxer no seleccionat.'
          },
          step3: {
            summary: 'Resum',
            cover: 'Portada',
            mapArea: 'Àrea del mapa',
            condicionesDeUso: {
              Parte1: 'Accepto les',
              Parte2: 'condicions d\'ús',
              Parte3: 'de Mapa a la Carta'
            },
            generatePDF: 'Generar PDF',
            pdfDescription1: 'Descarregar el mapa en format pdf a màxima resolució.',
            pdfDescription2: 'Aquest procés pot durar uns minuts.',
            buyPrint: 'Adquirir-ne una còpia impresa',
            printDescription: 'Rebre, per via postal, un duplicat del mapa que s\'ha generat.',
            paperType: 'Tipus de paper',
            paper: {
              normal: 'Normal',
              resistent: 'Resistent',
              plegado: 'Plegat',
              liso: 'Llis',
              glossy: 'Setinat',
              rigid: 'Rígid',
              photo: 'Fotográfico'
            },
            presentation: 'Presentació',
            buy: 'COMPRAR',
            addCart: 'AFEGIR A LA CISTELLA',
            price: 'Preu sense IVA (enviament no inclòs)',
            buyConditions: 'Condicions de compra',
            virtualShop: 'de la Botiga Virtual',
            frameColor: 'Color del marc',
            loaderAltaRes: 'Generant PDF en alta resolució.\nNo tanqueu el navegador, aquest procés pot durar uns minuts.',
            generatingSheet: 'Generant {Hjs} fulles.',
            loaderWait: 'Descarregant PDF\nEspereu uns segons...',
            GroupTotal: 'Total Sèrie:',
            add: 'Afegir',
            toCart: 'Anar a la cistella',
            cartConfirmation: 'Aquest producte ja està afegit a la cistella de la compra Voleu afegir més còpies o adreçar-vos a la cistella?',
            afterCart: 'INFORMACIÓ',
            stayPage: 'Romandre en aquesta pàgina',
            orderAdded: 'Comanda afegida a la cistella de la compra.'
          },
          dialog: {
            accept: 'Acceptar',
            noGeographicInformation: 'L\'àrea seleccionada no conté informació geogràfica. Si us plau, seleccioni una àrea corresponent a Espanya (Península, Canàries i Balears).',
            noGeographicInformation2: 'L\'àrea seleccionada no conté suficient informació geogràfica. Si us plau, seleccioni una àrea corresponent a Espanya (Península, Canàries i Balears).',
            noSeriesParameters: 'No teniu tots els requisits per entrar en aquesta pàgina. Ha de tenir com a mínim 2 fulls i cada full ha de tenir el títol i lautor introduïts.',
            noSeriesParametersEspecial: 'No teniu tots els requisits per entrar en aquesta pàgina. Ha de tenir com a mínim 2 fulls i cada full ha de tenir el títol, autor, NIPO, ISBN, Dipòsit Legal i codi de barres introduïts.',
            textFormError1: 'Per completar el mapa ha d\'introduir el títol i l\'autor.',
            textFormError1Serie: 'Per completar la sèrie, heu d\'introduir el títol i l\'autor en tots els fulls.',
            textFormError1Especial: 'Per completar mapa especial, heu d\'introduir el títol, autor, NIPO, ISBN, Dipòsit Legal i codi de barres.',
            textFormError1SerieEspecial: 'Per completar la sèrie especial, heu d\'introduir el títol, autor, NIPO, ISBN, Dipòsit Legal i codi de barres a tots els fulls.',
            notEnoughGeographicInformation: 'Falta part de la informació geogràfica de la zona. És possible que el seu mapa tingui zones blanques en imprimir.',
            uploadImage: 'Pujar Imatge',
            errorHeavyFile: 'La imatge que ha seleccionat excedeix la mida màxima establerta',
            back: 'Tornar',
            allowedFormats: 'Els formats permesos són',
            maxFileSize: 'La mida màxima de la imatge és de',
            bestResoultImage: 'Per a un resultat òptim, la imatge ha de tenir una proporció',
            uploadImageUpperCase: 'PUJAR IMATGE',
            cancel: 'CANCEL·LAR',
            close: 'TANCAR',
            generatePDFWarning: 'Està a punt de generar una cartografia en alta resolució en format PDF. L\'arxiu generat pot arribar a ser pesat, al voltant de 150 MB. Abans de continuar, consideri si el seu dispositiu o tarifa de dades li permet fer aquesta descàrrega. Aquest procés pot durar uns minuts.',
            generatePDFCompleted: {
              Parte1: 'El seu PDF de Mapa a la Carta s\'ha generat correctament.',
              Parte2: 'Podrà descarregar-lo ara o accedir més tard copiant el següent enllaç, que estarà',
              Parte3: 'disponible durant 7 dies:'
            },
            PDFGenerated: 'PDF generat',
            copyURL: 'COPIAR ENLLAÇ',
            copyID: 'COPIAR CODI',
            copyAllURL: 'COPIAR ENLLAÇOS',
            copyAllID: 'COPIAR CODIS',
            download: 'DESCARREGAR',
            cancelUpperCase: 'CANCEL·LAR',
            oldpdf: 'Comprar mapa',
            expiredpdf: 'L\'ID indicat ja s\'ha expirat',
            search: 'Cerca',
            idoldpdf: 'Codi del mapa',
            oldExplained: 'Buscar o encarregar un mapa generat anteriorment (7 dies)',
            validerror: 'Format no vàlid',
            duplicateerror: 'Ja present a la cistella',
            existanceerror: 'No existeix aquest PDF',
            RapidoElaborado: 'Ràpid o Elaborat',
            Poster: 'Pòster',
            Foto: 'Foto',
            snackBarURL: 'URL copiada al porta-retalls.',
            snackBarID: 'Codi copiat al porta-retalls.',
            serialOptions: 'Retrocedir i modificar aquestes configuracions pot causar pèrdua de configuració de fulls.',
            minSheet: "Hi ha d'haver com a mínim 2 fulls per seguir endavant.",
            generateLegend: 'Generar llegenda',
            generateLegendWarning: 'Es recomana configurar la llegenda en finalitzar la càrrega i simbolització de les dades afegides al mapa.',
            continue: 'CONTINUAR'
          },
          tour: {
            seriesOptionsStep1: 'A la primera pestanya es poden configurar les característiques de la sèrie completa. A la segona, el nombre de fulles i la seva posició.',
            productStep1: 'Trieu el producte que s\'utilitzarà a la sèrie.',
            step1FirstStepSeries: 'Trieu el producte que voleu consumir entre MTN25 i MTN50.',
            mapHelpStep1: 'Habilitar quadrícules dajuda.',
            step1FirstStep: 'En primer lloc, triï el producte que vulgui consumir entre MTN25 i MTN50.',
            step1SecondStep: 'Triï l\'escala del mapa generat:\n• 60K -> 1:60.000\n• 50K -> 1:50.000\n• 40K -> 1:40.000\n• 30K -> 1:30.000\n• 25K -> 1:25.000\n• 20K -> 1:20.000',
            step1SecondStepFoto: 'Triï l\'escala del mapa generat:\n• 25K -> 1:25.000\n• 10K -> 1:10.000\n• 5K -> 1:5.000\n• 2.5K -> 1:2.500',
            step1ThirdStep: 'Decideixi l\'orientació del mapa (horitzontal o vertical).',
            cartelaStep1: 'Decidiu l\'orientació de la cartel·la (horitzontal o vertical).',
            checkboxLegendStep1: 'Habilitar pòsters amb llegenda elaborada.',
            step1FourthStep: 'Pot afegir la quadrícula i/o les coordenades en el marc del mapa. Posteriorment, podrà seleccionar l\'ample de la quadrícula.',
            step1FifthStep: 'En aquesta finestra podrà seleccionar l\'àrea d\'impressió. Si fa clic sobre el marc del mapa, pot desplaçar-lo a una altra zona. Amb la roda del ratolí pot canviar el zoom.',
            hojaAddStep1: 'Afegir fulles a la sèrie, fins a un màxim de 10.',
            listHojaStep1: 'Llista de fulles enumerades al mapa.',
            listHojaStep2And3: 'Llista de fulles enumerades.',
            applyAllStep2: 'Botó per aplicar a la resta de fulls les mateixes configuracions d\'imatge, color i text.',
            focusHojaStep1: 'Centrar-se al full.',
            deleteHojaStep1: 'Esborrar el full.',
            step1SixthStep: 'Utilitzi el cercador per localitzar una ubicació concreta (comunitat autònoma, província, població o adreça postal).',
            step1SeventhStep: 'Si necessita generar un mapa d\'unes coordenades concretes, pot utilitzar el cercador de coordenades.',
            step1EighthStep: 'Posar el mapa a pantalla completa.',
            step1NinthStep: 'Amb aquesta eina podrà afegir elements al mapa. Pot agregar capes que ja existeixen o dibuixar les seves pròpies geometries. Si no té temps per continuar, podrà desar els canvis per continuar més tard.',
            step1NinthPointOneStep: 'Afegir un arxiu de l\'usuari. S\'admeten diferents formats.',
            step1NinthPointTwoStep: 'Dibuixar una entitat puntual. Es pot triar la simbologia. Tecla Esc per finalitzar.',
            step1NinthPointThreeStep: 'Dibuixar una entitat lineal. Es pot triar la simbologia. Doble clic per finalitzar.',
            step1NinthPointFourStep: 'Dibuixar una entitat superficial. Es pot triar la simbologia. Doble clic per finalitzar.',
            step1NinthPointFiveStep: 'Afegir un text. Es pot triar la simbologia. Tecla Esc per finalitzar.',
            step1NinthPointFiveTwoStep: 'Modificar estil. Premi l\'entitat i canviï l\'estil en el quadre de l\'esquerra. Tecla Esc per finalitzar.',
            step1NinthPointSixStep: 'Desplaçar una entitat. Premi l\'entitat i mogui-la a la ubicació desitjada.',
            step1NinthPointSevenStep: 'Editar una entitat. Premi sobre l\'entitat i desplaci els vèrtexs.',
            step1NinthPointEightStep: 'Eliminar una entitat. Premi sobre l\'entitat a eliminar.',
            step1AddLegend: 'Generar llegenda a partir de les entitats.',
            step1NinthPointNineStep: 'Carregar ruta del catàleg de rutes d\'oci i temps lliure. Premi la ruta a carregar.',
            step1NinthPointTenStep: 'Desar en un geoJSON les entitats dibuixades',
            step1NinthPointElevenStep: 'Desfer l\'última edició realitzada. Es poden encadenar diverses edicions.',
            step1TenthStep: 'Zoom a l\'escala del mapa.',
            step1EleventhStep: 'Zoom a l\'àrea d\'impressió.',
            step1TwelveStep: 'Inserir imatge en el mapa. Seleccioni la ubicació de la imatge i la mida final.',
            step1Or2Parameters: 'Personalitzi el mapa introduint-hi un títol (obligatori), un subtítol i un autor (obligatori).',
            step1FirstStepPhoto: 'Pot seleccionar els serveis que vol agregar al mapa.',
            step2FirstStep: 'En aquesta secció, personalitzarem el color de la portada.',
            specialStep2: 'Personalitza el mapa introduint un títol (obligatori), un subtítol, un autor (obligatori), un NIPO (obligatori), un ISBN (obligatori), un Dipòsit Legal (obligatori) i un codi de barres (obligatori).',
            step2ThirdStep: 'És hora de personalitzar la imatge de la portada. Pot afegir la seva pròpia imatge i editar-la al seu gust. Quan acabi, premi el botó \'Aplicar canvis\' de la part inferior.',
            step2FourthStep: 'Si no pot decidir la imatge. No es preocupi, tenim una llista d\'imatges predefinides perquè triï. Seleccioni el tema en les pestanyes i triï la que més li agradi.',
            step2FifthStep: 'Quan ho tingui tot enllestit, comprovi si li agrada perquè serà el resultat final de portada.',
            step3FirstStep: 'En aquesta última secció donarem els últims tocs al nostre mapa, aquí tenim el resultat final de la portada.',
            step3SecondStep: 'Aquí tenim el mapa que generarem, comprovi que el quadre coincideix amb la zona que desitja generar.',
            step3FourthStep: 'Si el resultat és el desitjat i vol generar el mapa en alta resolució o comprar-lo, accepti les condicions d\'ús.',
            step3FifthStep: 'Per generar el mapa en alta resolució, premi el botó \'Generar PDF\', aquest procés sol durar de 2 a 4 minuts.',
            step3SixthStep: 'En el cas que vulgui comprar el mapa, pot seleccionar el tipus de paper.\n• Normal: 75 gr/m²\n• Resistent: 75 gr/m². Material sintètic. Repel·leix l\'aigua i resistent a l\'esquinçament.',
            step3SixthStepPoster: 'En el cas que vulgui comprar el mapa, pot seleccionar el tipus de paper.\n• Normal: 75 gr/m²\n• Setinat\n• Rígid',
            step3SixthStepFoto: 'En el cas que vulgui comprar el mapa, pot seleccionar el tipus de paper.\n• Normal: 75 gr/m²\n• Fotogràfic\n• Rígid',
            step3SeventhStep: 'En aquesta secció podrem triar la manera de presentació del mapa.',
            step3EighthStep: 'Finalment, seleccioneu el nombre de còpies del mapa, podreu veure a més el preu de tots els mapes, en prémer afegir a la cistella el guardarà en aquest i en prémer comprar ens redirigirà a la botiga virtual d\'IGN per poder finalitzar la compra, però si hi ha alguna cosa al carret, et redirigirà a aquest per confirmar la compra sencera des daquí.',
            priceSeriesStep3: 'Preu total de tota la sèrie.',
            step3PFirstStep: 'En aquesta última secció donarem els últims tocs al nostre mapa. Primer, seleccioni un color per al marc del mapa.',
            step3FFirstStep: 'En aquesta última secció donarem els últims tocs al nostre mapa. Primer, seleccioni un color per al marc de la foto.',
            step3PFirstPointTwoStep: 'Personalitzi el seu mapa afegint-hi un títol (obligatori), un subtítol i un autor (obligatori).',
            step3PFirstPointTwoStepSpecial: 'Personalitza el teu mapa afegint-hi un títol (obligatori), un subtítol, un autor (obligatori), un NIPO (obligatori), un ISBN (obligatori), un dipòsit legal (obligatori) i un codi de barres (obligatori).'
          },
          wizardPanel: {
            help: 'Ajuda'
          },
          shoppingCart: {
            downloadMap: 'Descarregar mapa',
            unity: 'Unitat',
            removeProduct: 'Treure producte',
            cartDetail: 'Detall carret',
            name: 'Nom',
            units: 'Unitats',
            priceWithoutIVA: 'Preu (sense IVA)',
            totalWithoutIVA: 'Total (sense IVA)',
            addMoreMaps: 'Afegir més mapes',
            buy: 'Comprar',
            emptyCart: 'Buidar carret',
          }
        }
      },
      eu: {
        translation: {
          main: {
            title: 'Lortu zure mapa edo aireko argazkia pertsonalizatua!!',
            description: 'Mapa a la carta-k zure beharretara egokitutako mapa edo aireko argazkia sortzeko aukera ematen du Mapa Topografiko Nazionala 1:25.000 eta 1:50.000 eskaletan edo Aireko Ortofotografia Plan Nazionalean eskuragarri dagoen aireko argazkirik berriena erabiliz.<br><br>Eremua definitzeko, edukiak txertatzeko edo azala pertsonalizatzeko aukera izango duzu. PDF fitxategi bat deskargatu eta paperezko kopiak erosi ditzakezu.',
            LoginAdminButton: 'Administraziorako sarbidea',
            exit: 'Irten',
            name: 'Erabiltzaile izena',
            code: 'Pasahitza',
            avisoTienda: 'Euskarrian inprimatzea aldi baterako eten da obrak direla eta. Barkatu eragozpenak.'
          },
          boxComponent: {
            buttonText: 'Sartu',
            fastMapText: 'Klik gutxitan zure mapa nahierara sortu. Hautatu eremua, txertatu izenburua eta... Lortu zure mapa.',
            fastmapTitle: 'MAPA AZKARRA',
            completeMapText: 'Sortu mapa topografikoa ahalik eta pertsonalizaziorik handienarekin: mapan ibilbideak edo irudiak gehitu, marraztu, kartela konfiguratu, etab.',
            completeMapTitle: 'MAPA LANDUA',
            posterMapText: 'Kartela gabeko edizio berezia, markoztatzeko aproposa.',
            posterMapTitle: 'POSTER MAPA',
            photoMapText: 'Sortu aireko argazki bat zure interesgunean zentratuta.',
            photoMapTitle: 'ARGAZKIA NAHIERAN',
            seriesMapText: 'Sortu mapa edo argazki multzo bat ezarpen eta diseinu arruntekin.',
            seriesMapTitle: 'SAIL KARTOGRAFIKOA'
          },
          foot: {
            clientInformation: 'Bezeroarentzako informazioa',
            productCatalog: 'Produktuen katalogoa',
            purchaseConditions: 'Erosteko baldintzak',
            pointsOfSale: 'Salmenta puntuak',
            contactUs: 'Kontaktua',
            otherInformation: 'Bestelako informazioa',
            FAQ: 'Ohiko galderak',
            mapaWeb: 'Webaren Mapa',
            aboutUs: 'Guri buruz',
            politics: 'Politikak',
            legalWarning: 'Legezko oharra',
            intelectualProperty: 'Jabetza intelektuala',
            privacy: 'Pribatutasuna eta datuen babesa',
            cookies: 'Cookien informazioa',
            security: 'Segurtasuna'
          },
          step1: {
            mapDesign: 'Maparen diseinua',
            leftLabelTextTittle: 'MAPAREN DISEINUA',
            leftLabelDescription: 'Edukiak zure neurrira konfiguratu',
            centerLabelTextTittle: 'PORTADAREN DISEINUA',
            centerLabelDescription: 'Maparen informazioa pertsonalizatu',
            rightLabelTextTittle: 'LABURPENA',
            rightLabelDescription: 'Deskargatu eta eskuratu emaitzak',
            product: 'Produktua',
            scale: 'Eskala',
            orientation: 'Orriaren orientazioa',
            orientationCartela: 'Kartela orientazioa',
            cellDimension: 'Gelaxken neurriak',
            horizontal: 'Horizontala',
            vertical: 'Bertikala',
            grid: 'Laukia',
            coordinates: 'Koordenatuak',
            services: 'Inprimatu argazkiaren gainean',
            seeGrid: 'Bistaratzeko saretak',
            legend: 'Legenda',
            background: 'Markatu laukia eremu zuriak itsasoaren kolorez betetzeko',
            addSheet: 'Gehitu orria',
            listSheet: 'Orrialde zerrenda',
            selectSheet: 'Hautatu',
            removeSheet: 'Ezabatu',
            sheet: 'Orria',
            configSerie: 'Serie konfigurazioa',
            configSheet: 'Orriaren konfigurazioa',
            elaborado: 'Landua',
            poster: 'Poster',
            photo: 'Argazkia'
          },
          step2: {
            coverDesign: 'Azalaren diseinua',
            background: 'Atzeko planoa',
            texts: 'Testuak',
            title: 'Izenburua',
            subtitle: 'Azpititulua',
            author: 'Egilea',
            image: 'Irudia',
            uploadImage: 'Igo irudia',
            adventure: 'Abenturak',
            cartography: 'Kartografia',
            cities: 'Hiriak',
            nature: 'Natura',
            landscape: 'Paisaia',
            others: 'Beste batzuk',
            saveImageChanges: 'Aplikatu aldaketak',
            error_pdf_1: 'Errore bat gertatu da PDFa sortzean',
            error_pdf_2: 'Errore mota',
            error_pdf_3: 'Errorearen identifikatzailea',
            error_pdf_4: 'Mesedez, bidali mezu elektroniko bat errorearen identifikatzailearekin helbide honetara: <a href="mailto:consulta@cnig.es?subject=Error de Mapa a la Carta">consulta@cnig.es</a> (emailaren gaia: Error de Mapa a la Carta).',
            applyAll: 'Aplikatu guztiei',
            depLegal: 'Lege gordailua',
            codBar: 'Barra-kodea',
            selectedFile: 'Aurretik hautatutako fitxategia.',
            notSelectedFile: 'Ez da hautatu fitxategia.'
          },
          step3: {
            summary: 'Laburpena',
            cover: 'Azala',
            mapArea: 'Maparen eremua',
            condicionesDeUso: {
              Parte1: 'Mapa nahieran',
              Parte2: 'erabilera baldintzak',
              Parte3: 'onartzen ditut'
            },
            generatePDF: 'PDFa sortu',
            pdfDescription1: 'Deskargatu mapa pdf formatuan, bereizmen handienera.',
            pdfDescription2: 'Prozesu honek minutu batzuk iraun dezake.',
            buyPrint: 'Kopia inprimatua erosi',
            printDescription: 'Sortu den maparen kopia bat postaz jasotzea.',
            paperType: 'Paper mota',
            paper: {
              normal: 'Normala',
              resistent: 'Erresistentea',
              plegado: 'Tolestua',
              liso: 'Laua',
              glossy: 'Satinatua',
              rigid: 'Zurruna',
              photo: 'Argazki-papera'
            },
            presentation: 'Aurkezpena',
            buy: 'EROSI',
            addCart: 'GEHITU SASKIRA',
            price: 'Prezioa BEZik gabe (bidalketa ez dago barne)',
            buyConditions: 'Denda Birtualean',
            virtualShop: 'erosketa baldintzak',
            frameColor: 'Markoaren kolorea',
            loaderAltaRes: 'Bereizmen handiko PDFa sortzen.\nEz itxi arakatzailea, prozesu honek minutu batzuk behar izan ditzake.',
            generatingSheet: '{Hjs} orri sortzen.',
            loaderWait: 'PDFa deskargatzen\nItxaron segundo batzuk...',
            GroupTotal: 'Serieak guztira:',
            add: 'Gehitu',
            toCart: 'Joan saskira',
            cartConfirmation: 'Produktu hau dagoeneko gehitu da erosketa saskira. Kopia gehiago gehitu edo saskira joan nahi duzu?',
            afterCart: 'INFORMAZIOA',
            stayPage: 'Egon orrialde honetan',
            orderAdded: 'Eskaera erosketa saskian gehitu da.'
          },
          dialog: {
            accept: 'Onartu',
            noGeographicInformation: 'Hautatutako eremuak ez du informazio geografikorik. Mesedez, aukeratu Espainiako eremu bat (Penintsula, Kanariak eta Balearrak).',
            noGeographicInformation2: 'Hautatutako eremuak ez du informazio geografiko nahikorik. Mesedez, aukeratu Espainiako eremu bat (Penintsula, Kanariak eta Balearrak).',
            noSeriesParameters: 'Ez dituzu baldintza guztiak orri honetan sartzeko. Gutxienez 2 orrialde izan behar ditu eta orri bakoitzean izenburua eta egilea sartu behar dira.',
            noSeriesParametersEspecial: 'Ez dituzu baldintza guztiak orri honetan sartzeko. Gutxienez 2 orrialde izan behar ditu eta orri bakoitzean izenburua, egilea, NIPO, ISBN, Lege Gordailua eta barra-kodea sartu beharko dira.',
            textFormError1: 'Mapa osatzeko, izenburua eta egilea sartu behar dituzu.',
            textFormError1Serie: 'Seriea osatzeko, izenburua eta egilea idatzi behar dituzu orrialde guztietan.',
            textFormError1Especial: 'Mapa berezia osatzeko, izenburua, egilea, NIPO, ISBN, Lege Gordailua eta barra-kodea sartu behar dituzu.',
            textFormError1SerieEspecial: 'Serie berezia osatzeko, titulua, egilea, NIPO, ISBN, Lege Gordailua eta barra-kodea sartu behar dituzu orri guztietan.',
            notEnoughGeographicInformation: 'Inguruko informazio geografikoaren zati bat falta da. Baliteke zure mapak eremu zuriak izatea inprimatzean.',
            uploadImage: 'Igo irudia',
            errorHeavyFile: 'Hautatu duzun irudiak ezarritako muga-tamaina gainditzen du',
            back: 'Itzuli',
            allowedFormats: 'Hauek dira baimendutako formatuak',
            maxFileSize: 'Irudiaren gehienezko tamaina',
            bestResoultImage: 'Emaitza optimoa lortzeko, irudiak proportzio hau izan behar du',
            uploadImageUpperCase: 'IGO IRUDIA',
            cancel: 'EZEZTATU',
            close: 'ITXI',
            generatePDFWarning: 'Bereizmen handiko kartografia sortzear dago PDF formatuan. Sortutako fitxategia pisutsua izan daiteke, 150MB ingurukoa. Jarraitu aurretik, kontuan hartu zure gailuak edo datu-tarifak deskarga hori egiteko aukera ematen dizun. Prozesu honek minutu batzuk iraun dezake.',
            generatePDFCompleted: {
              Parte1: 'Zure mapako PDFa behar bezala sortu da.',
              Parte2: 'Orain deskargatu ahal izango duzu, edo geroago atzitu, esteka hau kopiatuz',
              Parte3: '7 egunez erabilgarri:'
            },
            PDFGenerated: 'PDF sortua',
            copyURL: 'KOPIATU ESTEKA',
            copyID: 'KOPIA KODEA',
            copyAllURL: 'KOPIATU ESTEKAK',
            copyAllID: 'KOPIA KODEAK',
            download: 'DESKARGATU',
            cancelUpperCase: 'EZEZTATU',
            oldpdf: 'Erosi mapa',
            expiredpdf: 'Adierazitako IDa dagoeneko iraungi da',
            search: 'Bilatu',
            idoldpdf: 'Maparen kodea',
            oldExplained: 'Bilatu edo eskatu aurretik sortutako mapa bat (7 egun)',
            validerror: 'Formatu baliogabea',
            duplicateerror: 'Dagoeneko gurdian presente',
            existanceerror: 'Ez dago horrelako PDFrik',
            RapidoElaborado: 'Azkarra edo Landua',
            Poster: 'Poster',
            Foto: 'Argazkia',
            snackBarURL: 'URLa arbelean kopiatu da.',
            snackBarID: 'Kodea arbelean kopiatu da.',
            serialOptions: 'Atzera egin eta ezarpen hauek aldatzeak orrien ezarpenak galtzea eragin dezake.',
            minSheet: 'Jarraitzeko, gutxienez 2 orri egon behar dira.',
            generateLegend: 'Sortu kondaira',
            generateLegendWarning: 'Mapan gehitutako datuak kargatzen eta sinbolizatzen amaitzean legenda konfiguratzea gomendatzen da.',
            continue: 'JARRAITU'
          },
          tour: {
            seriesOptionsStep1: 'Lehenengo fitxan serie osoaren ezaugarriak konfigura ditzakezu. Bigarrenean, hosto kopurua eta haien posizioa.',
            productStep1: 'Aukeratu seriean erabiliko den produktua.',
            step1FirstStepSeries: 'Aukeratu MTN25 eta MTN50 artean kontsumitu nahi duzun produktua.',
            mapHelpStep1: 'Gaitu laguntza-sareak.',
            step1FirstStep: 'Lehenik eta behin, aukeratu MTN25 eta MTN50 artean kontsumitu nahi duzun produktua.',
            step1SecondStep: 'Aukeratu sortutako maparen eskala:\n• 60K -> 1:60.000\n• 50K -> 1:50.000\n• 40K -> 1:40.000\n• 30K -> 1:30.000\n• 25K -> 1:25.000\n• 20K -> 1:20.000',
            step1SecondStepFoto: 'Aukeratu sortutako maparen eskala:\n• 25K -> 1:25.000\n• 10K -> 1:10.000\n• 5K -> 1:5.000\n• 2.5K -> 1:2.500',
            step1ThirdStep: 'Erabaki maparen orientazioa (horizontala edo bertikala).',
            cartelaStep1: 'Erabaki Kartela orientazioa (horizontala edo bertikala).',
            checkboxLegendStep1: 'Gaitu kondaira landua duen kartela.',
            step1FourthStep: 'Maparen markoan lauki-sarea edo/eta koordenatuak gehitu ditzakezu. Ondoren, lauki-sarearen zabalera aukeratu ahal izango duzu.',
            step1FifthStep: 'Leiho horretan inprimatzeko eremua aukeratu ahal izango duzu. Maparen markoan sakatzen baduzu, beste eremu batera eraman dezakezu. Saguaren gurpilarekin zooma alda dezakezu.',
            hojaAddStep1: 'Gehitu orriak serieari, gehienez 10.',
            listHojaStep1: 'Mapan zenbakitutako orrien zerrenda.',
            listHojaStep2And3: 'Zenbakitutako orrien zerrenda.',
            applyAllStep2: 'Gainontzeko orrietan irudi, kolore eta testu ezarpen berdinak aplikatzeko botoia.',
            focusHojaStep1: 'Fokua orrie.',
            deleteHojaStep1: 'Ezabatu orria.',
            step1SixthStep: 'Erabili bilatzailea kokapen jakin bat aurkitzeko (Autonomia-erkidegoa, probintzia, herria edo posta-helbidea).',
            step1SeventhStep: 'Koordenatu zehatz batzuen mapa sortu behar baduzu, koordenatu-bilatzailea erabil dezakezu.',
            step1EighthStep: 'Mapa pantaila osoan jarri.',
            step1NinthStep: 'Tresna honekin elementuak gehitu ahal izango zaizkio mapari. Lehendik dauden geruzak gehi ditzake, edo zeure geometriak marraztu. Edozein momentutan aldaketak gorde ahal izango dituzu, geroago jarraitzeko.',
            step1NinthPointOneStep: 'Erabiltzailearen fitxategi bat gehitzea. Hainbat formatu onartzen dira.',
            step1NinthPointTwoStep: 'Entitate puntual bat marraztea. Sinbologia hauta daiteke. Amaitzeko Esc tekla.',
            step1NinthPointThreeStep: 'Entitate lineal bat marraztea. Sinbologia hauta daiteke. Klik bikoitza amaitzeko.',
            step1NinthPointFourStep: 'Azaleko elementu bat marraztea. Sinbologia hauta daiteke. Klik bikoitza amaitzeko.',
            step1NinthPointFiveStep: 'Testu bat gehitzea. Sinbologia hauta daiteke. Amaitzeko Esc tekla.',
            step1NinthPointFiveTwoStep: 'Estiloa aldatzea. Sakatu entitatea eta aldatu estiloa ezkerreko koadroan. Amaitzeko Esc tekla.',
            step1NinthPointSixStep: 'Entitate bat lekuz aldatzea. Sakatu entitatea eta mugitu nahi duzun lekura.',
            step1NinthPointSevenStep: 'Entitate bat editatzea. Sakatu entitatearen gainean eta erpinak mugitu.',
            step1NinthPointEightStep: 'Entitate bat ezabatzea. Sakatu ezabatu beharreko entitatearen gainean.',
            step1AddLegend: 'Sortu kondaira entitateetatik.',
            step1NinthPointNineStep: 'Aisialdiko ibilbideen katalogotik ibilbidea kargatzea. Sakatu kargatu beharreko bidea.',
            step1NinthPointTenStep: 'Marraztutako erakundeak geoJSON batean gordetzea',
            step1NinthPointElevenStep: 'Egindako azken edizioa desegin. Hainbat edizio kateatu daitezke.',
            step1TenthStep: 'Zooma maparen eskalan.',
            step1EleventhStep: 'Zooma inprimaketa-eremura.',
            step1TwelveStep: 'Mapan irudia txertatzea. Aukeratu irudiaren kokapena eta azken tamaina.',
            step1Or2Parameters: 'Mapa pertsonalizatzea, izenburu bat (nahitaezkoa), azpititulu bat eta egile bat (nahitaezkoa) sartuta.',
            step1FirstStepPhoto: 'Mapan gehitu nahi dituzun zerbitzuak hauta ditzakezu.',
            step2FirstStep: 'Atal honetan, azalaren kolorea pertsonalizatuko dugu.',
            specialStep2: 'Mapa pertsonalizatzea, izenburu bat (nahitaezkoa), azpititulua, egilea (nahitaezkoa), NIPO (nahitaezkoa), ISBN (nahitaezkoa), Lege Gordailua (nahitaezkoa) eta barra-kode bat (nahitaezkoa) sartuta.',
            step2ThirdStep: 'Azaleko irudia pertsonalizatzeko garaia da. Zure irudia gehitu dezakezu eta zure gustura editatu. Amaitzen duzunean, sakatu\'Aldaketak aplikatu\' botoia behealdean.',
            step2FourthStep: 'Ezin baduzu irudia erabaki. Ez kezkatu, aurrez definitutako irudien zerrenda bat dugu zuk aukeratzeko. Aukeratu gaia eta erbaki gehien gustatzen zaizuna.',
            step2FifthStep: 'Dena prest duzunean, egiaztatu gustuko duzun, azaleko azken emaitza izango baita.',
            step3FirstStep: 'Azken atal honetan azken ukituak emango dizkiogu gure mapari, hemen dugu azalaren azken emaitza.',
            step3SecondStep: 'Hemen dugu sortuko dugun mapa, egiaztatu koadroa bat datorrela sortu nahi duzun eremuarekin.',
            step3FourthStep: 'Emaitza nahi duzuna bada eta mapa bereizmen handian sortu edo erosi nahi baduzu, onartu erabilera-baldintzak.',
            step3FifthStep: 'Bereizmen handiko mapa sortzeko, sakatu \'PDFa sortu\' botoia; prozesu horrek 2-4 minutu irauten du.',
            step3SixthStep: 'Mapa erosi nahi baduzu, paper mota aukera dezakezu.\n• Normala: 75 gr/m2\n• Erresistentea: 75 gr/m2. Material sintetikoa. Ura uxatzen du eta urradurarekiko erresistentea da.',
            step3SixthStepPoster: 'Mapa erosi nahi baduzu, paper mota aukera dezakezu.\n• Normala: 75 gr/m2\n• Satinatua\n• Zurruna',
            step3SixthStepFoto: 'Mapa erosi nahi baduzu, paper mota aukera dezakezu.\n• Normala: 75 gr/m2\n• Argazki-papera\n• Zurruna',
            step3SeventhStep: 'Atal honetan mapa aurkezteko modua aukeratu ahal izango dugu.',
            step3EighthStep: 'Azkenik, hautatu maparen kopia kopurua, mapa guztien prezioa ere ikusi ahal izango duzu, gehitu saskia saskian bertan gordeko da eta erosi sakatuz IGN denda birtualera birbideratuko gaitu. erosketa amaitzeko gai izan, baina saskian zerbait badago, bertara birbideratuko zaitu erosketa osoa berresteko.',
            priceSeriesStep3: 'Serie osoaren prezio osoa.',
            step3PFirstStep: 'Azken atal honetan azken ukituak emango dizkiogu gure mapari. Lehenik eta behin, aukeratu kolore bat maparen markorako.',
            step3FFirstStep: 'Azken atal honetan azken ukituak emango dizkiogu gure mapari. Lehenik eta behin, aukeratu kolore bat argazkiaren markorako.',
            step3PFirstPointTwoStep: 'Pertsonalizatu zure mapa izenburua (nahitaezkoa), azpititulua eta egilea (nahitaezkoa) gehituz.',
            step3PFirstPointTwoStepSpecial: 'Pertsonalizatu mapa gehituz izenburua (beharrezkoa), azpititulua, egilea (beharrezkoa), NIPO (beharrezkoa), ISBN (beharrezkoa), legezko gordailua (beharrezkoa) eta barra-kodea (beharrezkoa).'
          },
          wizardPanel: {
            help: 'Laguntza'
          },
          shoppingCart: {
            downloadMap: 'Deskargatu mapa',
            unity: 'Unitatea',
            removeProduct: 'Kendu produktua',
            cartDetail: 'Saskiaren xehetasuna',
            name: 'Izena',
            units: 'Unitateak',
            priceWithoutIVA: 'Prezioa (BEZ gabe)',
            totalWithoutIVA: 'Guztira (BEZ gabe)',
            addMoreMaps: 'Gehitu mapa gehiago',
            buy: 'Erosi',
            emptyCart: 'Orga hutsa',
          }
        }
      },
      gl: {
        translation: {
          main: {
            title: '¡¡Consiga o seu mapa ou foto aérea personalizado!!',
            description: 'Mapa a la carta permítelle crear un mapa ou fotografía aérea adaptada ás súas necesidades mediante o Mapa Topográfico Nacional a escalas 1:25.000 e 1:50.000 ou a fotografía aérea máis actual dispoñible no Plan Nacional de Ortofotografía Aérea.<br><br>Terás a posibilidade de definir a zona, incorporar contidos ou personalizar a portada. Podes descargar un ficheiro pdf e mercar copias en papel.',
            LoginAdminButton: 'Acceso administrativo',
            exit: 'Saír',
            name: 'Nome de usuario',
            code: 'Contrasinal',
            avisoTienda: 'A impresión en soporte ríxido está temporalmente suspendida por obras. Desculpen as molestias.'
          },
          boxComponent: {
            buttonText: 'Acceder',
            fastMapText: 'Xere en poucos clics o seu mapa á carta. Seleccione área, #inserir título e... obteña o seu mapa.',
            fastmapTitle: 'MAPA RÁPIDO',
            completeMapText: 'Xerar un mapa topográfico coa máxima personalización: engadir rutas ou imaxes no mapa, debuxar, configurar o portada, etc.',
            completeMapTitle: 'MAPA ELABORADO',
            posterMapText: 'Edición especial sen cartela, ideal para enmarcar.',
            posterMapTitle: 'MAPA PÓSTER',
            photoMapText: 'Xere unha foto aérea centrada na súa zona de interese.',
            photoMapTitle: 'FOTO Á CARTA',
            seriesMapText: 'Xera un conxunto de mapas ou fotos con configuracións e deseños comúns.',
            seriesMapTitle: 'SERIE CARTOGRÁFICA'
          },
          foot: {
            clientInformation: 'Información ó cliente',
            productCatalog: 'Catálogo de produtos',
            purchaseConditions: 'Condicións de compra',
            pointsOfSale: 'Puntos de venda',
            contactUs: 'Contactar',
            otherInformation: 'Outra información',
            FAQ: 'Preguntas frecuentes',
            mapaWeb: 'Mapa Web',
            aboutUs: 'Acerca de nós',
            politics: 'Políticas',
            legalWarning: 'Aviso legal',
            intelectualProperty: 'Propiedade intelectual',
            privacy: 'Privacidade e protección de datos',
            cookies: 'Información de cookies',
            security: 'Seguridade'
          },
          step1: {
            mapDesign: 'Deseño do mapa',
            leftLabelTextTittle: 'DESEÑO DO MAPA',
            leftLabelDescription: 'Configure os contidos a súa medida',
            centerLabelTextTittle: 'DESEÑO DA PORTADA',
            centerLabelDescription: 'Personalice a información do mapa',
            rightLabelTextTittle: 'RESUMO',
            rightLabelDescription: 'Descargue e adquira os resultados',
            product: 'Produto',
            scale: 'Escala',
            orientation: 'Orientación da lámina',
            orientationCartela: 'Orientación de cartela',
            cellDimension: 'Dimensións das celas',
            horizontal: 'Horizontal',
            vertical: 'Vertical',
            grid: 'Cuadrícula',
            coordinates: 'Coordenadas',
            services: 'Imprimir sobre a foto',
            seeGrid: 'Cuadrículas de visualización',
            legend: 'Lenda',
            background: 'Marque a caixa para encher as zonas brancas coa cor do mar',
            addSheet: 'Engadir folla',
            listSheet: 'Lista de follas',
            selectSheet: 'Seleccionar',
            removeSheet: 'Borrar',
            sheet: 'Folla',
            configSerie: 'Configuración de serie',
            configSheet: 'Configuración da folla',
            elaborado: 'Elaborado',
            poster: 'Cartel',
            photo: 'Foto'
          },
          step2: {
            coverDesign: 'Deseño da portada',
            background: 'Fondo',
            texts: 'Textos',
            title: 'Título',
            subtitle: 'Subtítulo',
            author: 'Autor',
            image: 'Imaxe',
            uploadImage: 'Subir imaxe',
            adventure: 'Aventuras',
            cartography: 'Cartografía',
            cities: 'Cidades',
            nature: 'Natureza',
            landscape: 'Paisaxe',
            others: 'Varios',
            saveImageChanges: 'Aplicar cambios produtos',
            error_pdf_1: 'Ocorreu un erro xerando o PDF',
            error_pdf_2: 'Tipo de erro',
            error_pdf_3: 'Identificador do erro',
            error_pdf_4: 'Por favor, envíe un email a <a href="mailto:consulta@cnig.es?subject=Error de Mapa a la Carta">consulta@cnig.es</a> co identificador do erro (asunto do email: Error de Mapa a la Carta).',
            applyAll: 'Aplicar a todos',
            depLegal: 'Depósito legal',
            codBar: 'Código de barras',
            selectedFile: 'Ficheiro seleccionado previamente.',
            notSelectedFile: 'Ficheiro non seleccionado.'
          },
          step3: {
            summary: 'Resumo',
            cover: 'Portada',
            mapArea: 'Área do mapa',
            condicionesDeUso: {
              Parte1: 'Acepto as',
              Parte2: 'condicións de uso',
              Parte3: 'de Mapa á Carta'
            },
            generatePDF: 'Xerar PDF',
            pdfDescription1: 'Descargar mapa en formato pdf a máxima resolución.',
            pdfDescription2: 'Este proceso pode durar uns minutos.',
            buyPrint: 'Adquirir copia impresa',
            printDescription: 'Recibir, por vía postal, un duplicado do mapa que se xerou.',
            paperType: 'Tipo de papel',
            paper: {
              normal: 'Normal',
              resistent: 'Resistente',
              plegado: 'Encartado',
              liso: 'Liso',
              glossy: 'Satinado',
              rigid: 'Ríxido',
              photo: 'Fotográfico'
            },
            presentation: 'Presentación',
            buy: 'COMPRAR',
            addCart: 'ENGADIR Á CESTA',
            price: 'Prezo sen IVE (envío non incluído)',
            buyConditions: 'Condicións de compra',
            virtualShop: 'da Tenda Virtuall',
            frameColor: 'Cor do marco',
            loaderAltaRes: 'Xerando PDF en alta resolución.\nNon peches o navegador, este proceso pode tardar uns minutos.',
            generatingSheet: 'Xerando {Hjs} follas.',
            loaderWait: 'Descargando PDF\nAgarde uns segundos...',
            GroupTotal: 'Serie total:',
            add: 'Engadir',
            toCart: 'Ir á cesta',
            cartConfirmation: 'Este produto xa foi engadido á cesta da compra. Queres engadir máis copias ou ir á cesta?',
            afterCart: 'INFORMACIÓN',
            stayPage: 'Quédese nesta páxina',
            orderAdded: 'Engadiuse o pedido á cesta da compra.'
          },
          dialog: {
            accept: 'Aceptar',
            noGeographicInformation: 'A área seleccionada non contén información xeográfica. Por favor seleccione unha área correspondente a España (Península, Canarias e Baleares).',
            noGeographicInformation2: 'A área seleccionada non contén suficiente información xeográfica. Por favor seleccione unha área correspondente a España (Península, Canarias e Baleares).',
            noSeriesParameters: 'Non tes todos os requisitos para entrar nesta páxina. Debe ter polo menos 2 follas e cada folla debe levar o título e o autor.',
            noSeriesParametersEspecial: 'Non tes todos os requisitos para entrar nesta páxina. Debe ter polo menos 2 páxinas e cada folla debe incluír o título, autor, NIPO, ISBN, Depósito Legal e código de barras.',
            textFormError1: 'Para completar o mapa debe introducir o título e o autor.',
            textFormError1Serie: 'Para completar a serie, debes introducir o título e o autor en todas as follas.',
            textFormError1Especial: 'Para completar o mapa especial, debes introducir o título, autor, NIPO, ISBN, Depósito Legal e código de barras.',
            textFormError1SerieEspecial: 'Para completar a serie especial, debes introducir o título, autor, NIPO, ISBN, Depósito Legal e código de barras en todas as follas.',
            notEnoughGeographicInformation: 'Falta parte da información xeográfica da zona. É posible que o seu mapa teña zonas brancas ao imprimir.',
            uploadImage: 'Subir Imaxe',
            errorHeavyFile: 'A imaxe que seleccionou excede o tamaño límite establecido',
            back: 'Volver',
            allowedFormats: 'Os formatos permitidos son',
            maxFileSize: 'O tamaño máximo da imaxe é de',
            bestResoultImage: 'Para un resultado óptimo, a imaxe debe ter unha proporción',
            uploadImageUpperCase: 'SUBIR IMAXE',
            cancel: 'CANCELAR',
            close: 'PECHA',
            generatePDFWarning: 'Está a piques de xerar unha cartografía en alta resolución en formato PDF. O arquivo xerado pode chegar a ser pesado, ao redor de 150MB. Antes de continuar, considere se o seu dispositivo ou tarifa de datos permítelle realizar esta descarga. Este proceso pode durar uns minutos.',
            generatePDFCompleted: {
              Parte1: 'O seu PDF de Mapa á Carta xerouse correctamente.',
              Parte2: 'Poderá descargalo agora ou acceder máis tarde copiando a seguinte ligazón que estará',
              Parte3: 'dispoñible durante 7 días:'
            },
            PDFGenerated: 'PDF xerado',
            copyURL: 'COPIAR ENLACE',
            copyID: 'COPIAR CÓDIGO',
            copyAllURL: 'COPIAR ENLACES',
            copyAllID: 'COPIAR CÓDIGOS',
            download: 'DESCARGAR',
            cancelUpperCase: 'CANCELAR',
            oldpdf: 'Comprar mapa',
            expiredpdf: 'O ID indicado xa caducou',
            search: 'Busca',
            idoldpdf: 'Código do mapa',
            oldExplained: 'Busca ou solicita un mapa xerado previamente (7 días)',
            validerror: 'Formato non válido',
            duplicateerror: 'Xa presente no carro',
            existanceerror: 'Non existe tal PDF',
            RapidoElaborado: 'Rápido ou Elaborado',
            Poster: 'Póster',
            Foto: 'Foto',
            snackBarURL: 'URL copiouse no portapapeis.',
            snackBarID: 'Código copiado no portapapeis.',
            serialOptions: 'Volver atrás e modificar esta configuración pode provocar a perda da configuración da folla.',
            minSheet: 'Debe haber polo menos 2 follas para continuar.',
            generateLegend: 'Xerar lenda',
            generateLegendWarning: 'Recoméndase configurar a lenda ao final da carga e simbolizar os datos engadidos ao mapa.',
            continue: 'CONTINUAR'
          },
          tour: {
            seriesOptionsStep1: 'Na primeira pestana podes configurar as características de toda a serie. No segundo, o número de follas e a súa posición.',
            productStep1: 'Escolla o produto que se vai utilizar na serie.',
            step1FirstStepSeries: 'Elixa o produto que queira consumir entre MTN25 e MTN50.',
            mapHelpStep1: 'Activa as cuadrículas de axuda.',
            step1FirstStep: 'En primeiro lugar, elixa o produto que queira consumir entre MTN25 e MTN50.',
            step1SecondStep: 'Escolla a escala do mapa xerado:\n• 60K -> 1:60.000\n• 50K -> 1:50.000\n• 40K -> 1:40.000\n• 30K -> 1:30.000\n• 25K -> 1:25.000\n• 20K -> 1:20.000',
            step1SecondStepFoto: 'Escolla a escala do mapa xerado:\n• 25K -> 1:25.000\n• 10K -> 1:10.000\n• 5K -> 1:5.000\n• 2.5K -> 1:2.500',
            step1ThirdStep: 'Decida a orientación do mapa (horizontal ou vertical).',
            cartelaStep1: 'Decide a orientación do cartela (horizontal ou vertical).',
            checkboxLegendStep1: 'Activa o póster cunha lenda elaborada.',
            step1FourthStep: 'Pode engadir a cuadrícula e/ou as coordenadas no marco do mapa. Posteriormente, poderá seleccionar o ancho da cuadrícula.',
            step1FifthStep: 'Nesta xanela poderá seleccionar a área de impresión. Se pulsa sobre o marco do mapa, pode desprazalo a outra zona. Coa roda do rato pode cambiar o zoom.',
            hojaAddStep1: 'Engade follas á serie, ata un máximo de 10.',
            listHojaStep1: 'Lista de follas numeradas no mapa.',
            listHojaStep2And3: 'Lista de follas numeradas.',
            applyAllStep2: 'Botón para aplicar a mesma configuración de imaxe, cor e texto ao resto das follas.',
            focusHojaStep1: 'Concéntrase na folla.',
            deleteHojaStep1: 'Elimina a folla.',
            step1SixthStep: 'Utilice o buscador para localizar unha localización concreta (CC.AA., provincia, poboación ou dirección postal).',
            step1SeventhStep: 'Se necesita xerar un mapa dunhas coordenadas concretas, pode utilizar o buscador de coordenadas.',
            step1EighthStep: 'Poñer o mapa a pantalla completa.',
            step1NinthStep: 'Con esta ferramenta poderá engadir elementos ao mapa. Pode agregar capas que xa existen, ou debuxar as súas propias xeometrías. Se non ten tempo para continuar, poderá gardar os seus cambios para continuar máis tarde.',
            step1NinthPointOneStep: 'Engadir un arquivo do usuario. Admítense diferentes formatos.',
            step1NinthPointTwoStep: 'Debuxar unha entidade puntual. Pódese elixir a simboloxía. Tecla Esc para finalizar.',
            step1NinthPointThreeStep: 'Debuxar unha entidade lineal. Pódese elixir a simboloxía. Dobre clic para finalizar.',
            step1NinthPointFourStep: 'Debuxar unha entidade superficial. Pódese elixir a simboloxía. Dobre clic para finalizar.',
            step1NinthPointFiveStep: 'Engadir un texto. Pódese elixir a simboloxía. Tecla Esc para finalizar.',
            step1NinthPointFiveTwoStep: 'Modificar estilo. Pulse a entidade e cambie o estilo no cadro da esquerda. Tecla Esc para finalizar.',
            step1NinthPointSixStep: 'Desprazar unha entidade. Pulse a entidade e móvaa á localización desexada.',
            step1NinthPointSevenStep: 'Editar unha entidade. Pulse sobre a entidade e desprace os vértices.',
            step1NinthPointEightStep: 'Eliminar unha entidade. Pulse sobre a entidade a eliminar.',
            step1AddLegend: 'Xerar lendas a partir das entidades.',
            step1NinthPointNineStep: 'Cargar roteiro do catálogo de roteiros de lecer e tempo libre. Pulse o roteiro para cargar.',
            step1NinthPointTenStep: 'Gardar nun geoJSON as entidades debuxadas',
            step1NinthPointElevenStep: 'Desfacer a última edición realizada. Pódense encadear varias edicións.',
            step1TenthStep: 'Zoom á escala do mapa.',
            step1EleventhStep: 'Zoom á área de impresión.',
            step1TwelveStep: 'Inserir imaxe no mapa. Seleccione a localización da imaxe e o tamaño final.',
            step1Or2Parameters: 'Personaliza o mapa introducindo un título (obrigatorio), un subtítulo e un autor (obrigatorio).',
            step1FirstStepPhoto: 'Pode seleccionar os servizos que quere agregar ao mapa.',
            step2FirstStep: 'Nesta sección, personalizaremos a cor da portada.',
            specialStep2: 'Personaliza o mapa introducindo un título (obrigatorio), un subtítulo, un autor (obrigatorio), un NIPO (obrigatorio), un ISBN (obrigatorio), un Depósito Legal (obrigatorio) e un código de barras (obrigatorio).',
            step2ThirdStep: 'É hora de personalizar a imaxe da portada. Podes engadir a túa propia imaxe e editala ao teu gusto. Cando termines, preme o botón \'Aplicar cambios\' da parte inferior.',
            step2FourthStep: 'Se non podes decidir a imaxe. Non te preocupes, temos unha lista de imaxes predefinidas para que escollas. Selecciona o tema nas pestanas e elixe a que máis che guste.',
            step2FifthStep: 'Cando o teñas todo listo, comproba se che gusta pois será o resultado final de portada.',
            step3FirstStep: 'Nesta última sección daremos os últimos toques ao noso mapa, aquí temos o resultado final da portada.',
            step3SecondStep: 'Aquí temos o mapa que imos xerar, comprobe que o cadro coincide coa zona que desexa xerar.',
            step3FourthStep: 'Se o resultado é o desexado e desexa xerar o mapa en alta resolución ou compralo, acepte as condicións de uso.',
            step3FifthStep: 'Para xerar o mapa en alta resolución, preme o botón \'Xerar PDF\', este proceso adoita durar entre 2-4 minutos.',
            step3SixthStep: 'No caso de que desexe comprar o mapa pode seleccionar o tipo de papel.\n• Normal: 75 gr/m2\n• Resistente: 75 gr/m2. Material sintético. Repele a auga e é resistente ao racho.',
            step3SixthStepPoster: 'No caso de que desexe comprar o mapa pode seleccionar o tipo de papel.\n• Normal: 75 gr/m2\n• Satinado\n• Ríxido',
            step3SixthStepFoto: 'No caso de que desexe comprar o mapa pode seleccionar o tipo de papel.\n• Normal: 75 gr/m2\n• Fotográfico\n• Ríxido',
            step3SeventhStep: 'Nesta sección poderemos elixir o modo de presentación do mapa.',
            step3EighthStep: 'Por último, selecciona o número de copias do mapa, tamén poderás ver o prezo de todos os mapas, premendo en engadir ao carro gardarase nel e premendo en mercar redirixiranos á tenda virtual de IGN para poder finalizar a compra, pero se hai algo no carro, redirixirache a el para confirmar a compra completa desde alí.',
            priceSeriesStep3: 'Prezo total de toda a serie.',
            step3PFirstStep: 'Nesta última sección daremos os últimos toques ao noso mapa. Primeiro, selecciona unha cor para o marco do mapa.',
            step3FFirstStep: 'Nesta última sección daremos os últimos toques ao noso mapa. Primeiro, selecciona unha cor para o marco da foto.',
            step3PFirstPointTwoStep: 'Personaliza o teu mapa engadindo un título (obrigatorio), subtítulo e autor (obrigatorio).',
            step3PFirstPointTwoStepSpecial: 'Personaliza o teu mapa engadindo un título (obrigatorio), subtítulo, autor (obrigatorio), NIPO (obrigatorio), ISBN (obrigatorio), depósito legal (obrigatorio) e código de barras (obrigatorio).'
          },
          wizardPanel: {
            help: 'Axuda'
          },
          shoppingCart: {
            downloadMap: 'Descargar mapa',
            unity: 'Unidade',
            removeProduct: 'Eliminar produto',
            cartDetail: 'Detalle do carro',
            name: 'Nome',
            units: 'Unidades',
            priceWithoutIVA: 'Prezo (sen IVE)',
            totalWithoutIVA: 'Total (sen IVE)',
            addMoreMaps: 'Engadir máis mapas',
            buy: 'Comprar',
            emptyCart: 'Carro baleiro',
          }
        }
      }
    }
  });

export default i18n;
